import { render, staticRenderFns } from "./Financial.vue?vue&type=template&id=0c196a6e&scoped=true&"
import script from "./Financial.vue?vue&type=script&lang=js&"
export * from "./Financial.vue?vue&type=script&lang=js&"
import style0 from "./Financial.vue?vue&type=style&index=0&id=0c196a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c196a6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
